import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

// *******************toster****************************
import Select from "react-select";
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import classNames from "classnames";
import JoditEditor from "jodit-react";
library.add(fas);

const AddOffCanvance = (props) => {
  const { postData, getData, Select2Data, getDimension } = useContext(Context);

  const [fuelType, setFuelType] = useState([]);
  const [cabCategory, setCabCategory] = useState([]);

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const GetAllFuelType = async () => {
    const response = await getData("/allfuel-type");

    if (response?.success) {
      setFuelType(await Select2Data(response?.data, "fuel_type_id"));
    }
  };
  const GetAllCabCategory = async () => {
    const response = await getData("/all-cab-category");

    if (response?.success) {
      setCabCategory(await Select2Data(response?.data, "cab_category_id"));
    }
  };
  const [seatCapacity, setSeatCapacity] = useState([]);

  const GetAllSeatCapacity = async () => {
    const response = await getData("/allseat-capacity");

    if (response?.success) {
      setSeatCapacity(await Select2Data(response?.data, "seat_capacity_id"));
    }
  };

  useEffect(() => {
    GetAllFuelType();
    GetAllSeatCapacity();
    GetAllCabCategory();
  }, []);

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    watch,
    trigger,
    setValue,
    getValues,
  } = useForm();
  const descriptionValue = watch("facilities");
  useEffect(() => {
    register("facilities", {
      required: "Facilities is required.",
    });
  }, [register]);
  const featuresAndAminitiesValue = watch("long_description");
  useEffect(() => {
    register("long_description", {
      required: "view More is required.",
    });
  }, [register]);

  const includedValue = watch("included");
  useEffect(() => {
    register("included", {
      required: "Included is required.",
    });
  }, [register]);
  const excludedValue = watch("excluded");
  useEffect(() => {
    register("excluded", {
      required: "Excluded is required.",
    });
  }, [register]);
  const imageFile = watch("image");
  const onSubmit = async (data) => {
    try {
      // console.log("faq_category_id :- ", data?.faq_category_id);
      const DataToSend = new FormData();
      DataToSend.append("image", data?.image[0]);
      DataToSend.append("fuel_type_id", data?.fuel_type_id?.value);
      DataToSend.append("name", data?.name);
      DataToSend.append("facilities", data?.facilities);
      DataToSend.append("included", data?.included);
      DataToSend.append("long_description", data?.long_description);
      DataToSend.append("excluded", data?.excluded);
      DataToSend.append("cancellation", data?.cancellation);
      DataToSend.append("fuel", data?.fuel);
      DataToSend.append("seat_capacity_id", data?.seat_capacity_id?.value);
      DataToSend.append("cab_name", data?.cab_name);
      DataToSend.append("sort_order", data?.sort_order);
      DataToSend.append("driver_payment", data?.driver_payment);

      DataToSend.append("cab_category_id", data?.cab_category_id?.value);
      const response = await postData(`/masters/cab-type`, DataToSend);

      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response.code, message: response.message });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="edit-modal-holder"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Add Cab Type</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            onSubmit={() => handleSubmit(onSubmit)}
            role="form"
          // className="stateclass"
          >
            <Row>

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Label>Cab Category</Form.Label>
                  <Controller
                    name="cab_category_id" // name of the field
                    {...register("cab_category_id", {
                      required: "Select Cab Category",
                    })}
                    control={control}
                    render={({ field }) => (
                      <Select
                        styles={{
                          control: (baseStyles) => ({
                            ...baseStyles,
                            borderColor: errors.cab_category_id
                              ? "red"
                              : baseStyles,
                          }),
                        }}
                        {...field}
                        options={cabCategory}
                      />
                    )}
                  />
                  {errors.cab_category_id && (
                    <span className="text-danger">
                      {errors.cab_category_id.message}
                    </span>
                  )}
                </div>
              </Col>
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>Cab Type Name</Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder="Cab Type"
                        className={classNames("", {
                          "is-invalid": errors?.name,
                        })}
                        {...register("name", {
                          required: "Name is required",
                          validate: (value) =>
                            value.length <= 200 ||
                            "Data must be 200 characters or less",
                        })}
                      />
                    </InputGroup>
                    {errors.name && (
                      <span className="text-danger">{errors.name.message}</span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              {/* <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>Driver Payment(per day)</Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        min={1}
                        name="driver_payment"
                        placeholder="Driver Payment"
                        className={classNames("", {
                          "is-invalid": errors?.driver_payment,
                        })}
                        {...register("driver_payment", {
                          required: "Driver Payment is required",
                          validate: (value) =>
                            value > 0 || "Fare must be greater than 0",
                        })}
                        onKeyDown={(e) => {
                          if (
                            e.key === "+" ||
                            e.key === "e" ||
                            e.key === "E" ||
                            (isNaN(Number(e.key)) &&
                              e.key !== "Backspace" &&
                              e.key !== "Tab" &&
                              e.key !== ".") || // Allow decimal point
                            (e.key === "." && e.target.value.includes(".")) // Prevent multiple decimal points
                          ) {
                            e.preventDefault();
                          }
                        }}
                        onPaste={(e) => {
                          const pasteData = e.clipboardData.getData("text");
                          if (!/^\d*\.?\d*$/.test(pasteData)) {
                            // Allow only numbers with optional single decimal
                            e.preventDefault();
                          }
                        }}
                      />
                    </InputGroup>
                    {errors.driver_payment && (
                      <span className="text-danger">
                        {errors.driver_payment.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col> */}

              {/* <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <div className="">
                      <Form.Label>Sort Order</Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        min={1}
                        name="sort_order"
                        placeholder="Sort Order"
                        className={classNames("", {
                          "is-invalid": errors?.sort_order,
                        })}
                        {...register("sort_order", {
                          required: "Sort order is required",
                          validate: (value) =>
                            value > 0 || "Sort order must be greater than 0",
                        })}
                        onKeyDown={(e) => {
                          if (
                            e.key === "+" ||
                            e.key === "e" ||
                            e.key === "E" ||
                            (isNaN(Number(e.key)) &&
                              e.key !== "Backspace" &&
                              e.key !== "Tab" &&
                              e.key !== ".") || // Allow decimal point
                            (e.key === "." && e.target.value.includes(".")) // Prevent multiple decimal points
                          ) {
                            e.preventDefault();
                          }
                        }}
                        onPaste={(e) => {
                          const pasteData = e.clipboardData.getData("text");
                          if (!/^\d*\.?\d*$/.test(pasteData)) {
                            // Allow only numbers with optional single decimal
                            e.preventDefault();
                          }
                        }}
                      />
                    </InputGroup>
                    {errors.sort_order && (
                      <span className="text-danger">
                        {errors.sort_order.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col> */}

              {/* <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Label>Cab Name</Form.Label>
                  <Form.Group>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder="Cab Name"
                        className={classNames("", {
                          "is-invalid": errors?.cab_name,
                        })}
                        {...register("cab_name", {
                          required: "cab Name is required",
                        })}
                      />
                    </InputGroup>
                    {errors.cab_name && (
                      <span className="text-danger">
                        {errors.cab_name.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col> */}
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Label>Seat Capacity</Form.Label>
                  <Controller
                    name="seat_capacity_id" // name of the field
                    {...register("seat_capacity_id", {
                      required: "Select Seat Capacity",
                    })}
                    control={control}
                    render={({ field }) => (
                      <Select
                        styles={{
                          control: (baseStyles) => ({
                            ...baseStyles,
                            borderColor: errors.seat_capacity_id
                              ? "red"
                              : baseStyles,
                          }),
                        }}
                        {...field}
                        options={seatCapacity}
                      />
                    )}
                  />
                  {errors.seat_capacity_id && (
                    <span className="text-danger">
                      {errors.seat_capacity_id.message}
                    </span>
                  )}
                </div>
              </Col>

              {/* <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Seater</Form.Label>
                    <Form.Group>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          name="seater"
                          placeholder="seater"
                          className={classNames("", {
                            "is-invalid": errors?.seater,
                          })}
                          {...register("seater", {
                            required: "Seater is required",
                            min: {
                              value: 0,
                              message: "Seater must be 0 or greater",
                            },
                            valueAsNumber: true, // To ensure the value is treated as a number
                            validate: (value) =>
                              (value >= 1 && value <= 100) ||
                              "Seater must be between 1 and 100",
                          })}
                          onInput={(e) => {
                            e.target.value = e.target.value.replace(
                              /[^0-9]/g,
                              ""
                            ); // Prevent non-numeric input
                          }}
                        />
                      </InputGroup>
                      {errors.seater && (
                        <span className="text-danger">
                          {errors.seater.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col> */}

              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Label>Fuel Type</Form.Label>
                  <Controller
                    name="fuel_type_id" // name of the field
                    {...register("fuel_type_id", {
                      required: "Select Fuel Type",
                    })}
                    control={control}
                    render={({ field }) => (
                      <Select
                        styles={{
                          control: (baseStyles) => ({
                            ...baseStyles,
                            borderColor: errors.fuel_type_id
                              ? "red"
                              : baseStyles,
                          }),
                        }}
                        {...field}
                        options={fuelType}
                      />
                    )}
                  />
                  {errors.fuel_type_id && (
                    <span className="text-danger">
                      {errors.fuel_type_id.message}
                    </span>
                  )}
                </div>
              </Col>

              {/* <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Label>Cancellation</Form.Label>
                  <Form.Group>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="cancellation"
                        placeholder="cancellation"
                        className={classNames("", {
                          "is-invalid": errors?.cancellation,
                        })}
                        {...register("cancellation", {
                          required: "cancellation is required",
                        })}
                      />
                    </InputGroup>
                    {errors.cancellation && (
                      <span className="text-danger">
                        {errors.cancellation.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col> */}
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Label>Facilities</Form.Label>
                  <Form.Group>
                    <InputGroup>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        name="facilities"
                        placeholder="Facilities"
                        className={classNames("", {
                          "is-invalid": errors?.facilities,
                        })}
                        {...register("facilities", {
                          required: "Facilities is required",
                        })}
                      />
                    </InputGroup>
                    {errors.facilities && (
                      <span className="text-danger">
                        {errors.facilities.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              <Col lg={6}>
                <div className="main-form-section mt-3">
                  <Form.Label className="text-left">Image</Form.Label>

                  <Form.Group>
                    <Form.Control
                      className={classNames("", {
                        "is-invalid": errors?.image,
                      })}
                      type="file"
                      {...register("image", {
                        required: "Image is required",
                        validate: async (value) => {
                          if (typeof value !== "string") {
                            const fileTypes = ["jpg", "png", "jpeg"];
                            const fileType = value[0].name?.split(".")[1];

                            if (!fileTypes.includes(fileType)) {
                              return `please upload a valid file format. (${fileTypes})`;
                            }

                            // const sizes = await getDimension(value[0]);
                            // if (sizes.width !== 352 && sizes.height !== 236) {
                            //   return "Image width and height must be 352 px and 236 px";
                            // }

                            // const fileSize = Math.round(
                            //   value[0].size / 1024
                            // );
                            // if (fileSize > 500) {
                            //   return "file size must be lower than 500kb";
                            // }
                          }
                        },
                      })}
                      accept=".jpg, .jpeg, .png"
                    />
                  </Form.Group>
                  {errors.image && (
                    <span className="text-danger">
                      {errors.image.message}
                    </span>
                  )}
                </div>
              </Col>
              <Col lg={3}>
                <div className="main-form-section mt-3">
                  <Form.Label>Image Preview</Form.Label>

                  {imageFile && imageFile?.length > 0 && (
                    <div className="image-preview-container mt-3">
                      <img
                        // src={URL.createObjectURL(getValues("image")[0])}
                        src={URL?.createObjectURL(imageFile[0])}
                        alt="Preview"
                        className="image-preview"
                      />
                    </div>
                  )}
                </div>
              </Col>

              {/* <Col lg={12}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-start">
                    {" "}
                   
                    <Col sm={12}>
                      <Form.Label className="text-center">
                        Facilities
                      </Form.Label>
                      <Form.Group>
                        <Controller
                          name="facilities" // Provide the field name
                          control={control} // Pass the control object from useForm()
                          rules={{
                            required: "facilities is required",
                          }} // Validation rules
                          render={({ field }) => (
                            <JoditEditor
                              value={descriptionValue || ""}
                              onBlur={(newContent) => {
                                setValue("facilities", newContent);
                                trigger("facilities");
                              }}
                            />
                          )}
                        />
                      </Form.Group>
                      {errors.facilities && (
                        <span className="text-danger">
                          {errors.facilities.message}
                        </span>
                      )}
                    </Col>
                  </Row>
                </div>
              </Col> */}

              <Col lg={12}>
                <div className="main-form-section mt-3">
                  <Form.Label className="text-center">View More</Form.Label>
                  <Form.Group>
                    <Controller
                      name="long_description" // Provide the field name
                      control={control} // Pass the control object from useForm()
                      rules={{
                        required: " Long Description is required",
                      }} // Validation rules
                      render={({ field }) => (
                        <JoditEditor
                          value={featuresAndAminitiesValue || ""}
                          onBlur={(newContent) => {
                            setValue("long_description", newContent);
                            trigger("long_description");
                          }}
                        />
                      )}
                    />
                  </Form.Group>
                  {errors.long_description && (
                    <span className="text-danger">
                      {errors.long_description.message}
                    </span>
                  )}
                </div>
              </Col>

              <Col lg={12}>
                <div className="main-form-section mt-3">
                  <Form.Label className="text-center">Included</Form.Label>
                  <Form.Group>
                    <Controller
                      name="included" // Provide the field name
                      control={control} // Pass the control object from useForm()
                      rules={{
                        required: "included is required",
                      }} // Validation rules
                      render={({ field }) => (
                        <JoditEditor
                          value={includedValue || ""}
                          onBlur={(newContent) => {
                            setValue("included", newContent);
                            trigger("included");
                          }}
                        />
                      )}
                    />
                  </Form.Group>
                  {errors.included && (
                    <span className="text-danger">
                      {errors.included.message}
                    </span>
                  )}
                </div>
              </Col>

              <Col lg={12}>
                <div className="main-form-section mt-3">
                  <Form.Label className="text-center">Excluded</Form.Label>
                  <Form.Group>
                    <Controller
                      name="excluded" // Provide the field name
                      control={control} // Pass the control object from useForm()
                      rules={{
                        required: " excluded is required",
                      }} // Validation rules
                      render={({ field }) => (
                        <JoditEditor
                          value={excludedValue || ""}
                          onBlur={(newContent) => {
                            setValue("excluded", newContent);
                            trigger("excluded");
                          }}
                        />
                      )}
                    />
                  </Form.Group>
                  {errors.excluded && (
                    <span className="text-danger">
                      {errors.excluded.message}
                    </span>
                  )}
                </div>
              </Col>

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>

                  <SaveButton
                    name={"save"}
                    handleSubmit={handleSubmit(onSubmit)}
                  />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default AddOffCanvance;
